import React from "react";
import CommonModal from "../CommonModal";
import Button from "../../Elements/Button";
import "../../Admin/Shared/AdminModal.css";

const MoveDataModel = ({ openModal, closeModal, userData, handleSubmit }) => {
    const kdfCount = userData?.docs_count ?? 0;
    const tlCount = userData?.tracking_links_count ?? 0;
    const lastLogin = userData?.last_logged_in || "Never";

    return (
        <>
            <CommonModal
                title={"Move Data"}
                modalStatus={openModal}
                changeActiveStatus={() => closeModal()}
                classList="header-profile-modal-wrapper admin-modal move-data-modal"
                size="lg"
                centered
            >
                <div className="admin-confirmation-modal-body" style={{ textAlign: "left" }}>
                    <p className="admin-confirmation-modal-message mb-3">
                        Overview for <strong>{userData?.name}</strong>:
                    </p>
                    <div className="admin-table-wrapper mb-4">
                        <table className="table-main">
                            <tbody>
                                <tr>
                                    <td>KDFs created</td>
                                    <td><strong>{kdfCount}</strong></td>
                                </tr>
                                <tr>
                                    <td>LaserLINX created</td>
                                    <td><strong>{tlCount}</strong></td>
                                </tr>
                                <tr>
                                    <td>Last login</td>
                                    <td><strong>{lastLogin}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="admin-confirmation-modal-actions">
                        <Button
                            text="MOVE KDFs & LaserLINX and REMOVE this User"
                            classList="primary1"
                            addonClass="admin-confirmation-yes common-modal-yes-button"
                            type="submit"
                            onClick={handleSubmit}
                        />
                        <Button
                            text="Cancel"
                            classList="primary"
                            addonClass="admin-confirmation-no"
                            onClick={closeModal}
                        />
                    </div>
                </div>
            </CommonModal>
        </>
    );
};
export default MoveDataModel;
